import { useTranslation } from 'react-i18next'
import { Download } from 'lucide-react'
import { approxVoiceSizeMb } from '@/application/tts/voice-catalogue'
import { Button } from '@/ui/components/common/Button'

interface ReadAloudConsentPromptProps {
  onAccept: () => void
  onDecline: () => void
}

/** First-click prompt: the site voices are a one-time download per
 * language, so nothing is fetched until the visitor agrees. */
export function ReadAloudConsentPrompt({ onAccept, onDecline }: ReadAloudConsentPromptProps) {
  const { t } = useTranslation()

  return (
    <div
      role="group"
      aria-label={t('read_mode.listen.consent_title')}
      className="read-aloud__consent flex flex-col gap-3 rounded-2xl border border-input bg-background p-4 text-sm print:hidden"
    >
      <p className="text-foreground">
        {t('read_mode.listen.consent_body', { size: approxVoiceSizeMb() })}
      </p>
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" onClick={onAccept}>
          <Download className="mr-2 h-4 w-4" aria-hidden="true" />
          {t('read_mode.listen.consent_download')}
        </Button>
        <Button type="button" size="sm" variant="outline" onClick={onDecline}>
          {t('read_mode.listen.consent_device')}
        </Button>
      </div>
    </div>
  )
}
